import React from 'react';
import { useAgent } from '../context/AgentContext';
import WelcomeScreen from '../components/dashboard/WelcomeScreen';
import AgentWorkspace from '../components/dashboard/AgentWorkspace';
import './Dashboard.css';

const Dashboard = () => {
  const { selectedAgent } = useAgent();

  return (
    <div className="dashboard">
      {selectedAgent ? (
        <AgentWorkspace />
      ) : (
        <WelcomeScreen />
      )}
    </div>
  );
};

export default Dashboard;
